import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'
import Panel from 'components/Panel'
import GoogleSearch from 'containers/ESSearch/GoogleSearch'

const TryGoogle = styled.div`
  text-align: center;
  color: var(--dark-gray);
  margin-top: 10px;
`

const Wrapper = styled.div`
  padding: 20px 0;

  .filter {
    padding-bottom: 20px;
  }
  .filter ul {
    max-height: none;
  }

  .filter h2 {
    font-weight: bold;
    font-size: 14px;
  }

  .filter label {
    font-weight: normal;
    font-size: 14px;
  }
  .filter label::before {
    width: 18px;
  }

  .filter input {
    height: 32px;
  }
`

const ESSearch = ({ searchQuery, filters, results }) => {
  if (!searchQuery || searchQuery.trim() === '') {
    return null
  }

  return (
    <Panel title={searchQuery || 'Search results'}>
      <Wrapper>
        <Row>
          <Col xs={12} md={3}>{filters}</Col>
          <Col xs={12} md={9}>{results}</Col>
        </Row>
      </Wrapper>

      <TryGoogle>
        <GoogleSearch query={searchQuery} />
      </TryGoogle>
    </Panel>
  )
}

export default ESSearch
